import * as React from 'react'

import { observer } from 'mobx-react'

import { LocationType } from '~/client/graph'
import LocationParentPicker from '~/client/src/shared/components/LocationPicker/LocationParentPicker'
import IHierarchyParent from '~/client/src/shared/types/IHierarchyParent'

import MapViewItemsSetupStore from '../../stores/MapViewItemsSetup.store'

interface IProps {
  label: string
  /** Shown behind an info icon beside the label. */
  labelTooltip?: string
  updateObjectParent?: (parent: IHierarchyParent) => void
  store: MapViewItemsSetupStore
}

@observer
export default class ParentsSelector extends React.Component<IProps> {
  public render() {
    const {
      store: { selectedMapViewItem },
      label,
      labelTooltip,
    } = this.props
    if (!selectedMapViewItem) {
      return null
    }
    const { parent, dataObject, isDataLess } = selectedMapViewItem
    const isHidden = isDataLess || dataObject.is(LocationType.ProjectLocation)
    if (isHidden) {
      return null
    }

    return (
      <LocationParentPicker
        label={label}
        labelTooltip={labelTooltip}
        value={parent}
        onChange={this.onItemSelect}
        objectId={dataObject.id}
        isClearDisabled
      />
    )
  }

  private onItemSelect = (selectedParent: IHierarchyParent) => {
    const { updateObjectParent, store } = this.props
    const {
      selectedMapViewItem,
      addCurrentStateToHistory,
      resetAccessibleLevels,
      hierarchyAttributes,
    } = store

    selectedMapViewItem.setParent(selectedParent || null)

    // A map object takes its parent's color, the way it always has when reparented
    // here. The picker hands back the id, so the color is looked up rather than read
    // off the attribute it used to be handed directly.
    const parentAttribute =
      selectedParent &&
      hierarchyAttributes.find(({ id }) => id === selectedParent.parentId)
    if (parentAttribute) {
      selectedMapViewItem.setAllColors(parentAttribute.color)
    }

    resetAccessibleLevels(selectedMapViewItem)
    addCurrentStateToHistory()

    updateObjectParent?.(selectedMapViewItem.parent)
  }
}
